import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop — scrolls the window to the top on forward navigation.
 *
 * Behaviour:
 *  - PUSH / REPLACE (clicking a link, navigating programmatically) → scroll to top.
 *  - POP (browser back / forward buttons) → do nothing, let the browser
 *    restore the previous scroll position naturally.
 *
 * Watches both pathname AND search params so that query-string changes
 * (pagination, category switches, etc.) also trigger a scroll reset.
 *
 * Place this component inside <BrowserRouter> so it has access to the
 * router context. It renders nothing to the DOM.
 */
function ScrollToTop() {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname, search, navigationType]);

  return null;
}

export default ScrollToTop;
